import React, { useState, useEffect } from 'react';

import config from '../../config/config';
import { useResto } from '../../contexts/RestoContext';
import { useLanguage } from '../../contexts/LanguageContext';
import Contact from '../Contact';

const SocialMedias = () => {
  const { activeLanguage } = useLanguage();
  const { restoData } = useResto();
  
  const [tripAdvisorUrl, setTripAdvisorUrl] = useState(null);

  useEffect(() => {
    const tripAdvisorBaseUrl = {
      de: 'tripadvisor.de',
      en: 'tripadvisor.com',
      es: 'tripadvisor.es',
    }[activeLanguage] || 'tripadvisor.fr';

    if (restoData.socialMediaTripAdvisorUrl) {
      const updatedUrl = restoData.socialMediaTripAdvisorUrl.replace('tripadvisor.fr', tripAdvisorBaseUrl);
      setTripAdvisorUrl(updatedUrl);
    } else {
      setTripAdvisorUrl(null);
    }
  }, [activeLanguage, restoData.socialMediaTripAdvisorUrl]);

  const iconSuffix = restoData.hasSquareSocialMediaIcons ? '_square_icon_128.png' : '_icon_128.png';
  const iconPath = `${config.kubuniImagesUrl}general-icons/`;

  return (
    <>
      <Contact />
      <div className="text-center" style={{ margin: '30px 0' }}>

          {restoData.socialMediaInstagramUrl && (
            <a href={restoData.socialMediaInstagramUrl} style={{ margin: '0 10px' }}>
              <img src={`${iconPath}instagram${iconSuffix}`} alt="Instagram" height="64" className="social-icon" />
            </a>
          )}

          {restoData.socialMediaYoutubeUrl && (
            <a href={restoData.socialMediaYoutubeUrl} style={{ margin: '0 10px' }}>
              <img src={`${iconPath}youtube${iconSuffix}`} alt="YouTube" height="64" className="social-icon" />
            </a>
          )}
          
          {tripAdvisorUrl && (
            <a href={tripAdvisorUrl} style={{ margin: '0 10px' }}>
              <img src={`${iconPath}tripadvisor${iconSuffix}`} alt="TripAdvisor" height="64" className="social-icon" />
            </a>
          )}
          {restoData.socialMediaFacebookUrl && (
            <a href={restoData.socialMediaFacebookUrl} style={{ margin: '0 10px' }}>
              <img src={`${iconPath}facebook${iconSuffix}`} alt="Facebook" height="64" className="social-icon" />
            </a>
          )}
      </div>

    </>
  );
}

export default SocialMedias;
